const SelectCustomStyles = {
    indicatorSeparator: provided => ({
        ...provided,
        "&:not(.separator-allowed)": {
            display: "none"
        }
    }),
    option: (provided, state) => ({
        ...provided,
        "&:active": {
            backgroundColor: "#EFEFEF"
        },
        backgroundColor:
            state.isFocused && state.isSelected
                ? "#000066"
                : state.isSelected
                ? "#000066"
                : state.isFocused
                ? "#f1f1f1"
                : "white",
        color:
            state.isFocused && state.isSelected
                ? "white"
                : state.isSelected
                ? "white"
                : "#161616",

        padding: 14
    }),
    control: (provided, state) => ({
        ...provided,
        boxShadow: `none`,
        borderColor: state.isFocused ? `#0000FF` : `#cccccc`,
        borderRadius: 0,
        borderWidth: 1,
        "&:hover": {
            borderColor: state.isFocused ? "#0000FF" : "#cccccc"
        },
        'input[type="text"]': { height: 20 },
        minHeight: 48,
        padding: "0.275rem 1rem"
    }),
    valueContainer: provided => ({
        ...provided,
        minHeight: 25,
        padding: 0
    }),
    singleValue: provided => ({
        ...provided,
        color: "#161616"
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        padding: 0,
        "&:not(.no-animation)": {
            transform: state.selectProps.menuIsOpen && "rotate(180deg)",
            transition: "transform 300ms ease-in"
        }
    }),
    multiValueRemove: provided => ({
        ...provided,
        "&:hover": {
            backgroundColor: "#357C834C",
            color: "#357C83",
            cursor: "pointer"
        }
    }),
    menu: provided => ({
        ...provided,
        zIndex: 3,
        "@media only screen and (max-width: 567px)": {
            ...provided["@media only screen and (max-width: 567px)"],
            "&:last-child": {
                zIndex: 6
            }
        }
    }),
    menuList: provided => ({
        ...provided,
        maxHeight: 410
    })
};
export { SelectCustomStyles };
